import React, { Component } from 'react'
import Modal from 'react-modal'
import { isNotEmpty } from "../../../utilities/FrontFunctions/AoxFrontFunctions"

const customStyles = {
	overlay : {
		zIndex			: '99999',
		backgroundColor	: 'rgba(0,0,0,0.6)'
	},
	content : {
		position	: 'fixed',
		top			: '50%',
		left		: '50%',
		right		: 'auto',
		bottom		: 'auto',
		transform	: 'translate(-50%, -50%)',
		outline		: '0'
	}
}

Modal.setAppElement('#root')

class DefaultModal extends Component {
    constructor(props) {
        super(props)
		this.state = {
			modalIsOpen: false,
            mainText: this.props.mainText,
            titleText: this.props.titleText
		}
		this.openModal = this.openModal.bind(this)
		this.closeModal = this.closeModal.bind(this)
        this.handleAction = this.handleAction.bind(this);
	}
	componentDidMount() {
		this.props.onRef(this)
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	openModal(titleText, mainText) {
		this.setState({modalIsOpen: true})
        if(isNotEmpty(titleText)){ this.setState({titleText:titleText}) }
        if(isNotEmpty(mainText)){ this.setState({mainText:mainText}) }
	}

	closeModal() {
		this.setState({modalIsOpen: false})
	}

    handleAction() {
        if (this.props.handleAction) {
            this.props.handleAction();
        }
        this.closeModal();
    }

	render() {
		if(this.props.onClose){
			this.closeModal = this.props.onClose
		}
		return (
			<div>
				<Modal
					isOpen={this.state.modalIsOpen}
					onRequestClose={this.closeModal}
					style={customStyles}
					className={'obj_popin ' + this.props?.className}
					closeTimeoutMS={300}
					contentLabel="Modal"
				>
					<button className="bt_close" onClick={this.closeModal}></button>
					<div className="ctn_popin">
                        {this.state.titleText && <p className="t_title">{this.state.titleText}</p>}
						{this.state.mainText && <p className="t_main">{this.state.mainText}</p>}

						{this.props.htmlContent}

                        {this.props.handleAction && 
                            <div className="ctn_cta">
                                <button
                                    className="obj_cta"
                                    type="button"
                                    onClick={this.handleAction}
                                >
                                    {this.props.actionText}
                                </button>
                            </div>
                        }

						{this.props.action === "close" && 
                            <div className="ctn_cta">
                                <button className="obj_cta" type="button" onClick={this.closeModal}>fermer</button>
                            </div>
                        }
					</div>
				</Modal>
			</div>
		)
	}
}

export default DefaultModal